export default "__VITE_ASSET__DUweZYNp__"